import { useEffect } from "react"
import { useHoverIntent } from "react-use-hoverintent"

export interface HoverIntentProps {
  onMouseOver: () => void
  onMouseOut: () => void
  children: React.ReactNode
  sensitivity?: number
  timeout?: number
  interval?: number
}

export const HoverIntent: React.FC<HoverIntentProps> = ({
  onMouseOver,
  onMouseOut,
  children,
  sensitivity,
  timeout,
  interval,
}) => {
  const [hovered, intentRef] = useHoverIntent({
    interval,
    timeout,
    sensitivity,
  })

  useEffect(() => {
    if (hovered) {
      onMouseOver()
    } else {
      onMouseOut()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hovered])

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
  return <div ref={intentRef as any}>{children}</div>
}

export default HoverIntent
